export const AI_WAGE_PREMIUM_BASELINE = 56 // PwC 2025 Global AI Jobs Barometer median premium (%)
export const DATA_LAST_UPDATED = 'Q1 2025'
export const DATA_SOURCES = [
  'PwC Global AI Jobs Barometer 2025',
  'U.S. Bureau of Labor Statistics (BLS) Occupational Employment Statistics',
  'O*NET OnLine',
  'WEF Future of Jobs Report 2025'
] as const
export const PREMIUM_SOURCE = 'PwC Global AI Jobs Barometer 2025'
export const PREMIUM_SOURCE_URL = 'https://www.pwc.com/gx/en/issues/aijobs-barometer.html'
